"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _uuid = _interopRequireDefault(require("uuid"));
var _webexCore = require("@webex/webex-core");
var _triggerProxy = _interopRequireDefault(require("../common/events/trigger-proxy"));
var _constants = require("./constants");
var _constants2 = require("../constants");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } } // eslint-disable-next-line import/no-extraneous-dependencies
/**
 * @description Annotation to handle LLM and Mercury message and locus API
 * @class
 */
var AnnotationChannel = /*#__PURE__*/function (_WebexPlugin) {
  (0, _inherits2.default)(AnnotationChannel, _WebexPlugin);
  var _super = _createSuper(AnnotationChannel);
  /**
   * Initializes annotation module
   */
  function AnnotationChannel() {
    var _this;
    (0, _classCallCheck2.default)(this, AnnotationChannel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "namespace", _constants.ANNOTATION);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "seqNum", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasSubscribedToEvents", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "approvalUrl", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "locusUrl", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "deviceUrl", void 0);
    /**
     * send annotation command
     * @param {ANNOTATION_ACTION_TYPE} actionType
     * @param {RequestData} requestData
     * @returns {Promise}
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "sendAnnotationAction", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(actionType, requestData) {
        var body;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              body = {
                actionType: actionType,
                resourceType: 'AnnotationOnShare',
                shareInstanceId: requestData.shareInstanceId
              };
              if (requestData !== null && requestData !== void 0 && requestData.toUserId) {
                body.receivers = [{
                  participantId: requestData.toUserId,
                  deviceUrl: requestData.toDeviceUrl
                }];
              }

              // @ts-ignore
              return _context.abrupt("return", _this.request({
                method: _constants2.HTTP_VERBS.POST,
                url: "".concat(_this.approvalUrl),
                body: body
              }));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    /**
     * decrypt data
     * @param {string} encryptionKeyUrl
     * @param {string} content encrypted content
     * @returns {string} decrypted content
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "decryptContent", function (encryptionKeyUrl, content) {
      // @ts-ignore
      return _this.webex.internal.encryption.decryptText(encryptionKeyUrl, content).then(function (res) {
        return res;
      });
    });
    /**
     * encrypt data
     * @param {string} encryptionKeyUrl
     * @param {string} content original content
     * @returns {string} encrypted content
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "encryptContent", function (encryptionKeyUrl, content) {
      // @ts-ignore
      return _this.webex.internal.encryption.encryptText(encryptionKeyUrl, content).then(function (res) {
        return res;
      });
    });
    /**
     * Sends stroke data to presenter
     * @param {StrokeData} strokeData
     * @returns {void}
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "sendStrokeData", function (strokeData) {
      // @ts-ignore
      if (!_this.webex.internal.llm.isConnected()) return;
      _this.encryptContent(strokeData.encryptionKeyUrl, strokeData.content).then(function (encryptedContent) {
        _this.publishEncrypted(encryptedContent, strokeData);
      });
    });
    _this.seqNum = 1;
    return _this;
  }

  /**
   * Process Stroke Data
   * @param {object}  data
   * @returns {void}
   */
  (0, _createClass2.default)(AnnotationChannel, [{
    key: "processStrokeMessage",
    value: function processStrokeMessage(data) {
      var _this2 = this;
      var request = data.request;
      this.decryptContent(request.value.encryptionKeyUrl, request.value.content).then(function (decryptedContent) {
        request.value.content = decryptedContent;
        _triggerProxy.default.trigger(_this2, {
          file: 'annotation',
          function: 'processStrokeMessage'
        }, _constants.EVENT_TRIGGERS.ANNOTATION_STROKE_DATA, {
          payload: data
        });
      });
    }

    /** bind all events from mercury
     * @param {Object} e
     * @returns {undefined}
     */
  }, {
    key: "eventCommandProcessor",
    value: function eventCommandProcessor(e) {
      var _e$data, _e$data2, _e$data2$approval, _e$data3, _e$data3$approval;
      if ((e === null || e === void 0 ? void 0 : (_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.eventType) === 'locus.approval_request' && (e === null || e === void 0 ? void 0 : (_e$data2 = e.data) === null || _e$data2 === void 0 ? void 0 : (_e$data2$approval = _e$data2.approval) === null || _e$data2$approval === void 0 ? void 0 : _e$data2$approval.resourceType) === _constants.ANNOTATION_RESOURCE_TYPE && e !== null && e !== void 0 && (_e$data3 = e.data) !== null && _e$data3 !== void 0 && (_e$data3$approval = _e$data3.approval) !== null && _e$data3$approval !== void 0 && _e$data3$approval.actionType) {
        _triggerProxy.default.trigger(this, {
          file: 'annotation',
          function: 'approval_request'
        }, _constants.EVENT_TRIGGERS.ANNOTATION_COMMAND, {
          type: e.data.approval.actionType,
          payload: e.data.approval
        });
      }
    }

    /** bind all events from llm
     * @param {Object} e
     * @returns {undefined}
     */
  }, {
    key: "eventDataProcessor",
    value: function eventDataProcessor(e) {
      var _e$data4;
      switch (e === null || e === void 0 ? void 0 : (_e$data4 = e.data) === null || _e$data4 === void 0 ? void 0 : _e$data4.relayType) {
        case _constants.ANNOTATION_RELAY_TYPES.ANNOTATION_CLIENT:
          this.processStrokeMessage(e.data);
          break;
        default:
          break;
      }
    }

    /**
     * Listen to websocket messages
     * @returns {undefined}
     */
  }, {
    key: "listenToEvents",
    value: function listenToEvents() {
      if (!this.hasSubscribedToEvents) {
        // @ts-ignore
        this.webex.internal.mercury.on('event:locus.approval_request', this.eventCommandProcessor, this);
        // @ts-ignore
        this.webex.internal.llm.on('event:relay.event', this.eventDataProcessor, this);
        this.hasSubscribedToEvents = true;
      }
    }

    /**
     * Remove event listeners
     * @returns {undefined}
     */
  }, {
    key: "deregisterEvents",
    value: function deregisterEvents() {
      if (this.hasSubscribedToEvents) {
        // @ts-ignore
        this.webex.internal.mercury.off('event:locus.approval_request', this.eventCommandProcessor);

        // @ts-ignore
        this.webex.internal.llm.off('event:relay.event', this.eventDataProcessor);
        this.hasSubscribedToEvents = false;
      }
    }

    /**
     * set locusUrl
     * @param {string} locusUrl
     * @returns {void}
     */
  }, {
    key: "locusUrlUpdate",
    value: function locusUrlUpdate(locusUrl) {
      this.locusUrl = locusUrl;
      this.listenToEvents();
    }

    /**
     * set approved url
     * @param {string} approvalUrl
     * @returns {void}
     */
  }, {
    key: "approvalUrlUpdate",
    value: function approvalUrlUpdate(approvalUrl) {
      this.approvalUrl = approvalUrl;
    }

    /**
     * accept request
     * @param {object} approval
     * @returns {Promise}
     */
  }, {
    key: "acceptRequest",
    value: function acceptRequest(approval) {
      // @ts-ignore
      return this.request({
        method: _constants2.HTTP_VERBS.PUT,
        url: approval.url,
        body: {
          resourceType: _constants.ANNOTATION_RESOURCE_TYPE,
          actionType: _constants.ANNOTATION_ACTION_TYPE.ACCEPTED
        }
      });
    }

    /**
     * presenter declined request annotation
     * @param {approval} approval
     * @returns {Promise}
     */
  }, {
    key: "declineRequest",
    value: function declineRequest(approval) {
      // @ts-ignore
      return this.request({
        method: _constants2.HTTP_VERBS.PUT,
        url: approval.url,
        body: {
          resourceType: _constants.ANNOTATION_RESOURCE_TYPE,
          actionType: _constants.ANNOTATION_ACTION_TYPE.DECLINED
        }
      });
    }

    /**
     * request approved annotation
     * @param {RequestData} requestData
     * @returns {Promise}
     */
  }, {
    key: "approveAnnotation",
    value: function approveAnnotation(requestData) {
      return this.sendAnnotationAction(_constants.ANNOTATION_ACTION_TYPE.REQUESTED, requestData);
    }

    /**
     * cancel approved annotation
     * @param {object} requestData
     * @param {object} approval
     * @returns {Promise}
     */
  }, {
    key: "cancelApproveAnnotation",
    value: function cancelApproveAnnotation(requestData, approval) {
      var body = {
        actionType: _constants.ANNOTATION_ACTION_TYPE.CANCELED,
        resourceType: 'AnnotationOnShare',
        shareInstanceId: requestData.shareInstanceId
      };

      // @ts-ignore
      return this.request({
        method: _constants2.HTTP_VERBS.PUT,
        url: "".concat(approval.url),
        body: body
      });
    }

    /**
     * close annotation
     * @param {object} requestData
     * @returns {Promise}
     */
  }, {
    key: "closeAnnotation",
    value: function closeAnnotation(requestData) {
      return this.sendAnnotationAction(_constants.ANNOTATION_ACTION_TYPE.CLOSED, requestData);
    }
  }, {
    key: "publishEncrypted",
    value:
    /**
     * private encrypted the strokes data
     * @param {string} encryptedContent
     * @param {StrokeData} strokeData
     * @returns {void}
     */
    function publishEncrypted(encryptedContent, strokeData) {
      var data = {
        id: "".concat(this.seqNum),
        type: 'publishRequest',
        recipients: {
          // @ts-ignore
          route: this.webex.internal.llm.getBinding()
        },
        headers: {
          to: strokeData.toUserId
        },
        data: {
          eventType: 'relay.event',
          relayType: _constants.ANNOTATION_RELAY_TYPES.ANNOTATION_CLIENT,
          request: {
            value: {
              type: _constants.ANNOTATION_REQUEST_TYPE.ANNOTATION_MESSAGE,
              content: encryptedContent,
              deviceId: strokeData.deviceId,
              seq: this.seqNum,
              requesterId: strokeData.requesterId,
              version: strokeData.version,
              shareInstanceId: strokeData.shareInstanceId,
              encryptionKeyUrl: strokeData.encryptionKeyUrl
            }
          }
        },
        trackingId: "".concat(_webexCore.config.trackingIdPrefix, "_").concat(_uuid.default.v4().toString()),
        timestamp: new Date().getTime(),
        sequenceNumber: this.seqNum,
        filterMessage: false
      };

      // @ts-ignore
      this.webex.internal.llm.socket.send(data);
      this.seqNum += 1;
    }
  }]);
  return AnnotationChannel;
}(_webexCore.WebexPlugin);
var _default = exports.default = AnnotationChannel;
//# sourceMappingURL=index.js.map
